import React from "react";
import { FiChevronRight } from "react-icons/fi";
import { Link } from "react-router-dom";

export default function DesktopProfileMenuIcon({ data,index }) {
  return (
    <Link
      to={data?.linkTo}
      className={`sidebar-li inline-block rounded-md  ${`#${data?.linkTo}` === window?.location?.hash ? 'active' : ''
        }`}
      key={index}
    >
      <li
        className={' flex gap-4 items-center text-navLink p-2 '}
      >
        <div className="w-6 h-6">{data?.icon}</div>
        <p className="text-navLink baseText">{data?.name}</p>
        <div className="size-9 rounded-full ms-auto inline-flex justify-center items-center">
          <FiChevronRight className="text-lg text-coalBlack" />
        </div>
      </li>
    </Link>
  )
}